import { LockKeyhole, User, X } from 'lucide-react';
import type { ReactNode } from 'react';
import type { Person } from '../types';

export function cx(...classes: Array<string | false | null | undefined>) {
  return classes.filter(Boolean).join(' ');
}

export const fieldClass =
  'w-full rounded-[10px] border border-white/15 bg-ink/55 px-3 py-2.5 text-sm text-pearl outline-none transition placeholder:text-pearl/35 focus:border-jade/60 focus:ring-2 focus:ring-jade/10';

export function PersonAvatar({ person, large = false }: { person: Person; large?: boolean }) {
  return (
    <div className={cx('person-avatar', large && 'large')} aria-label={`${person.name}头像`}>
      <User className={cx('text-ink/45', large ? 'h-14 w-14' : 'h-7 w-7')} />
      {person.status === 'pending' && <span className="avatar-status" />}
      {person.privacy !== 'public' && !large && <LockKeyhole className="avatar-lock" />}
    </div>
  );
}

export function Field({ label, hint, children, className }: { label: string; hint?: string; children: ReactNode; className?: string }) {
  return (
    <label className={cx('form-field', className)}>
      <span className="form-label">{label}</span>
      {children}
      {hint && <span className="form-hint">{hint}</span>}
    </label>
  );
}

export function Modal({ title, subtitle, onClose, children, size = 'large' }: { title: string; subtitle?: string; onClose: () => void; children: ReactNode; size?: 'small' | 'medium' | 'large' | 'wide' }) {
  return (
    <div className="modal-backdrop" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className={cx('modal-panel', `modal-${size}`)} role="dialog" aria-modal="true" aria-label={title}>
        <header className="modal-header">
          <div>
            <h2>{title}</h2>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <button type="button" className="icon-button" onClick={onClose} aria-label="关闭"><X /></button>
        </header>
        <div className="modal-content">{children}</div>
      </section>
    </div>
  );
}

export function EmptyState({ title, description }: { title: string; description: string }) {
  return (
    <div className="empty-state">
      <strong>{title}</strong>
      <span>{description}</span>
    </div>
  );
}
